<template>
<div class="quizier-module module-media">
    <div class="preview" v-if="image_preview">
        <img :src="image_preview" :class="effect_class" class="img-fluid">
        <div class="blur-overlay" @click="toggle_blur" v-if="elem_selected == 'blur' && !uncover">
            <div class="svg-holder" v-html="svg('click')"></div>
        </div>
        <div class="blur-uncover" @click="toggle_blur" v-if="elem_selected == 'blur' && uncover"></div>
    </div>
</div>
</template>

<script>
import mixinComponent from '../mixins';

export default {
    props: [],
    mixins: [mixinComponent],
    data() {
        return {
            uncover: false,
        }
    },
    computed: {
        image_preview: function () {
            return this.has('media_path');
        },
        elem_selected: function () {
            return this.has('effect');
        },
        effect_class: function () {
            var effect = this.has('effect');
            var className = effect;

            if (effect == 'blur' && !this.uncover) {
                className = 'blur';
            } else if (effect == 'blur' && this.uncover) {
                className = 'unblur';
            }
            return className;
        },
    },
    methods: {
        toggle_blur: function () {
            this.uncover = !this.uncover;
        },
        update_effect: function (active) {
            this.uncover = false;
            this._updateValue('data.effect', active);
        },
    },
    mounted: function () {

    }
}
</script>
